module.exports = __webpack_public_path__ + "img/email.c858e64b.png";